import { generateBFFUrl } from '@/configs/apiEndPoints';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import axiosInstance from '../axiosConfig';
import { ECOM_FOOTER_DETAIL } from '@/configs/ecom/apis';
import dlv from 'dlv';
import { transformHeaderItems } from '@/utils';

export const getFooterDetail = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(ECOM_FOOTER_DETAIL), {
      params: {
        populate: 'socialLinks.icon,footerLinks,moreShoppingLinks.icon,columns.list.links',
      },
    });

    const footer = dlv(response, 'data.data.attributes', {});
    if (footer?.socialLinks) {
      footer.socialLinks = transformHeaderItems(footer.socialLinks);
    }
    return footer;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
